import React from 'react'
import { Button, ButtonGroup, Card, Badge, Modal, Form, Alert } from 'react-bootstrap'
import { FaPlus, FaCheck, FaFilePdf, FaFileImage, FaFileAlt, FaCarAlt, FaUpload, FaDownload, FaTimes, FaExclamationTriangle, FaTimesCircle } from 'react-icons/fa'
import { useStateAuthContext, useStateHostContext } from '../context';
import Swal from 'sweetalert2'

const Admin_alih_status_kendaraan = () => {
    const { STATE_AUTH } = useStateAuthContext();
    const { HOST } = useStateHostContext();
    const [data_alih_status, setData_alih_status] = React.useState([])
    const [data_kendaraan, setData_kendaraan] = React.useState([])
    const [data_opd, setData_opd] = React.useState([])
    const [daftar_kendaraan_teralih, setDaftarKendaraanTeralih] = React.useState([])
    const [expandedRow, setExpandedRow] = React.useState(null);
    const [viewType, setViewType] = React.useState(null); // 'kendaraan' or 'dokumen'
    const [loading, setLoading] = React.useState(false);
    const [showUploadModal, setShowUploadModal] = React.useState(false);
    const [showProsesMutasiModal, setShowProsesMutasiModal] = React.useState(false);
    const [currentUploadType, setCurrentUploadType] = React.useState('');
    const [currentAlihStatusId, setCurrentAlihStatusId] = React.useState('');
    const [uploadFile, setUploadFile] = React.useState(null);
    const [nomorSurat, setNomorSurat] = React.useState('');
    const [tglSurat, setTglSurat] = React.useState('');
    const [currentItem, setCurrentItem] = React.useState(null);

    const handleGetData = React.useCallback(async () => {
        setLoading(true);
        try {
            const param = {
                method: 'GET',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                }
            }
            const requ = await fetch(HOST + '/alih_status/ambil_semua', param)
            const resp = await requ.json()

            if (requ.ok) {
                if (resp.s === true) {
                    setData_alih_status(resp.d)
                    setDaftarKendaraanTeralih(resp.d?.flatMap(item => item.daftar_kendaraan).map(k => k.id) || []);
                }
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    }, [HOST, STATE_AUTH])

    const handleAmbilDataKendaraan = React.useCallback(async () => {
        const resp = await fetch(HOST + '/admin/kendaraan', {
            method: 'GET',
            headers: {
                'REST-TOKEN': STATE_AUTH.token,
                'REST-ID-OPD': STATE_AUTH.id_opd
            }
        })
        const resu = await resp.json()
        setData_kendaraan(resu.d)
    }, [HOST, STATE_AUTH])

    const handleAmbilDataOpd = React.useCallback(async () => {
        const requ = await fetch(HOST + '/opd/ambil', {
            method: 'GET',
            headers: {
                'REST-TOKEN': STATE_AUTH.token,
                'REST-ID-OPD': STATE_AUTH.id_opd
            }
        })
        const resp = await requ.json()
        if (requ.ok && resp.s === true) {
            setData_opd(resp.d)
        }
    }, [HOST, STATE_AUTH])

    React.useEffect(() => {
        handleGetData()
        handleAmbilDataKendaraan()
        handleAmbilDataOpd()
    }, [handleAmbilDataKendaraan, handleAmbilDataOpd, handleGetData])

    const handleViewDocuments = (index, type) => {
        if (expandedRow === index && viewType === type) {
            setExpandedRow(null);
            setViewType(null);
        } else {
            // Otherwise, open the new view
            setExpandedRow(index);
            setViewType(type);
        }
    }

    const isDocumentComplete = (item) => {
        return (
            item.dok_permohonan_setda && item.no_surat_dok_permohonan_setda &&
            item.dok_ketersediaan_menerima && item.no_surat_dok_ketersediaan_menerima &&
            item.dok_persetujuan && item.no_surat_persetujuan &&
            item.dok_bast && item.no_surat_bast
        );
    };

    const getDocumentIcon = (documentUrl) => {
        if (!documentUrl) return null;

        const extension = documentUrl.split('.').pop().toLowerCase();

        if (extension === 'pdf') {
            return <FaFilePdf className="text-danger" size={100} />;
        } else if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) {
            return <FaFileImage className="text-primary" size={100} />;
        } else {
            return <FaFileAlt className="text-muted" size={100} />;
        }
    };

    const validateFileType = (file) => {
        if (!file) return false;

        const allowedTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/pdf'];
        const allowedExtensions = ['.doc', '.docx', '.pdf'];

        const fileType = file.type;
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

        return allowedTypes.includes(fileType) || allowedExtensions.includes(fileExtension);
    };

    const handleOpenUploadModal = (alihStatusId, docType) => {
        setCurrentAlihStatusId(alihStatusId);
        setCurrentUploadType(docType);
        setNomorSurat('');
        setUploadFile(null);
        setShowUploadModal(true);
    };

    const handleCloseUploadModal = () => {
        setShowUploadModal(false);
        setCurrentAlihStatusId('');
        setCurrentUploadType('');
        setNomorSurat('');
        setUploadFile(null);
    };

    const handleOpenProsesMutasiModal = (item) => {
        setCurrentAlihStatusId(item.id_alih_status);
        setCurrentItem(item);
        setUploadFile(null);
        setShowProsesMutasiModal(true);
    };

    const handleCloseProsesMutasiModal = () => {
        setShowProsesMutasiModal(false);
        setCurrentAlihStatusId('');
        setUploadFile(null);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (validateFileType(file)) {
                setUploadFile(file);
            } else {
                alert('Format file tidak didukung. Silakan upload file dengan format: DOC, DOCX, atau PDF');
                e.target.value = null; // Reset the file input
            }
        }
    };

    const handleProsesMutasiFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            if (validateFileType(file)) {
                setUploadFile(file);
            } else {
                alert('Format file tidak didukung. Silakan upload file dengan format: DOC, DOCX, atau PDF');
                e.target.value = null; // Reset the file input
            }
        }
    };

    const handleProsesMutasiSubmit = async (e) => {
        e.preventDefault();

        if (!uploadFile) {
            alert('Silakan pilih file BAST terlebih dahulu');
            return;
        }

        // Show loading indicator using SweetAlert
        Swal.fire({
            title: 'Mengupload dokumen BAST...',
            text: 'Mohon tunggu sebentar, dokumen BAST sedang diproses',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const formData = new FormData();
            formData.append('OPD_ASAL', data_opd.find(opd => opd.id === currentItem.id_opd_asal)?.opd || '');
            formData.append('OPD_TUJUAN', data_opd.find(opd => opd.id === currentItem.id_opd_tujuan)?.opd || '');
            formData.append('FILE_BAST', uploadFile); // BAST template
            formData.append('DATA_LAIN', JSON.stringify(currentItem));

            const param = {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: formData
            };

            const response = await fetch(HOST + '/alih_status/proses_mutasi', param);
            const result = await response.json();

            Swal.close(); // Close the loading dialog

            if (response.ok && result.s) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: 'Dokumen BAST berhasil diupload',
                    icon: 'success',
                    confirmButtonColor: '#0d6efd'
                });

                // Refresh data after successful upload
                handleGetData();
                handleCloseProsesMutasiModal();
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: result.m || 'Gagal mengupload dokumen BAST',
                    icon: 'error',
                    confirmButtonColor: '#0d6efd'
                });
            }
        } catch (error) {
            console.error('Error uploading BAST file:', error);
            Swal.close(); // Close the loading dialog
            Swal.fire({
                title: 'Error!',
                text: 'Terjadi kesalahan saat mengupload dokumen BAST',
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    const handleUploadSubmit = async (e) => {
        e.preventDefault();

        if (!uploadFile) {
            alert('Silakan pilih file terlebih dahulu');
            return;
        }

        if (!nomorSurat.trim()) {
            alert('Silakan masukkan Nomor Surat Permohonan');
            return;
        }

        if (!tglSurat.trim()) {
            alert('Silakan masukan tgl surat');
            return;
        }

        // Show loading indicator using SweetAlert
        Swal.fire({
            title: 'Mengupload dokumen...',
            text: 'Mohon tunggu sebentar, dokumen sedang diproses',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const formData = new FormData();
            formData.append('TEMPLATE', currentUploadType);
            formData.append('NOMOR_SURAT', nomorSurat);
            formData.append('FILE_TEMPLATE', uploadFile);
            formData.append('TANGGAL_SURAT', tglSurat);
            formData.append('ID_ALIH_STATUS', currentAlihStatusId);

            const param = {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: formData
            };

            const response = await fetch(HOST + '/alih_status/update_template', param);
            const result = await response.json();

            Swal.close(); // Close the loading dialog

            if (response.ok && result.s) {
                Swal.fire({
                    title: 'Berhasil!',
                    text: 'Dokumen berhasil diupload',
                    icon: 'success',
                    confirmButtonColor: '#0d6efd'
                });

                // Refresh data after successful upload
                handleGetData();
                handleCloseUploadModal();
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: result.m || 'Gagal mengupload dokumen',
                    icon: 'error',
                    confirmButtonColor: '#0d6efd'
                });
            }
        } catch (error) {
            console.error('Error uploading file:', error);
            Swal.close(); // Close the loading dialog
            Swal.fire({
                title: 'Error!',
                text: 'Terjadi kesalahan saat mengupload dokumen',
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    const handleDownloadDocument = async ({ items, template }) => {
        // Show loading with progress
        Swal.fire({
            title: 'Memproses...',
            text: 'Sedang mengunduh dokumen, mohon tunggu sebentar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const fd = new FormData();
            fd.append('ID_ALIH_STATUS', items.id_alih_status);
            fd.append('OPD_ASAL', data_opd.find(opd => opd.id === items.id_opd_asal)?.opd || '');
            fd.append('OPD_TUJUAN', data_opd.find(opd => opd.id === items.id_opd_tujuan)?.opd || '');
            fd.append('ID_OPD_TUJUAN', items.id_opd_tujuan);
            fd.append('ID_KENDARAAN', items.id_kendaraan);
            fd.append('DATA_LAIN', JSON.stringify(items));

            const req = await fetch(HOST + '/alih_status/cetak/' + template, {
                method: 'POST',
                headers: {
                    'REST-TOKEN': STATE_AUTH.token,
                    'REST-ID-OPD': STATE_AUTH.id_opd
                },
                body: fd
            });

            // Close the loading dialog
            Swal.close();

            if (!req.ok) {
                // Handle 4xx and 5xx errors
                if (req.status >= 400 && req.status < 600) {
                    let errorMessage = 'Gagal mengunduh dokumen';
                    try {
                        const errorResponse = await req.json();
                        errorMessage = errorResponse.m || errorResponse.message || errorMessage;
                    } catch (e) {
                        // If response is not JSON, use default error message
                        errorMessage = `Gagal mengunduh dokumen. Kode error: ${req.status}`;
                    }

                    Swal.fire({
                        title: 'Gagal!',
                        text: errorMessage,
                        icon: 'error',
                        confirmButtonColor: '#0d6efd'
                    });
                }
                return;
            }

            // --- Ambil nama file dari header ---
            const disposition = req.headers.get('Content-Disposition');
            let filename = "dokumen.docx";

            if (disposition) {
                // 1. Utamakan filename* (UTF-8)
                const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/);
                if (utfMatch && utfMatch[1]) {
                    filename = decodeURIComponent(utfMatch[1]);
                } else {
                    // 2. Fallback ke filename="....."
                    const normalMatch = disposition.match(/filename="([^"]+)"/);
                    if (normalMatch && normalMatch[1]) {
                        filename = normalMatch[1];
                    }
                }
            }

            // --- Proses download ---
            const blob = await req.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename; // ← nama dari server
            a.click();

            window.URL.revokeObjectURL(url);

        } catch (error) {
            // Close the loading dialog if there's an error
            Swal.close();

            // Show error notification
            Swal.fire({
                title: 'Gagal!',
                text: 'Terjadi kesalahan saat mengunduh dokumen: ' + error.message,
                icon: 'error',
                confirmButtonColor: '#0d6efd'
            });
        }
    };

    return (
        <main>
            <div className="container-fluid">

                <div className="row mt-3">
                    <div className="col-md-12">
                        <h3><strong><i className='fa fa-exchange-alt'></i> ALIH STATUS KENDARAAN</strong></h3>
                    </div>
                </div>
                <hr />
                <div className="row mt-2">
                    <div className="table-responsive">
                        {loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <table className="tb-daftar-dinas mt-1">
                                <thead>
                                    <tr>
                                        <th>No</th>
                                        <th>Opd Asal</th>
                                        <th>Opd Tujuan</th>
                                        <th>Status</th>
                                        <th>Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data_alih_status.map((item, index) => (
                                        <React.Fragment key={item.id_alih_status}>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{item.opd_asal}</td>
                                                <td>{item.opd_tujuan}</td>
                                                <td>
                                                    <Badge bg={
                                                        item.status === 'pending' || item.status === 'diajukan' ? 'warning' :
                                                            item.status === 'menerima' ? 'info' :
                                                                item.status === 'disetujui' ? 'success' :
                                                                    item.status === 'menolak' || item.status === 'rejected' ? 'danger' : 'secondary'
                                                    }>
                                                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                                    </Badge>
                                                </td>
                                                <td className='text-center'>
                                                    <ButtonGroup>
                                                        {/* <Button size='sm' variant='outline-warning' onClick={() => handleViewDocuments(index, 'kendaraan')} disabled>
                                                            <FaExclamationTriangle /> Daftar Kendaraan
                                                        </Button> */}
                                                        <Button
                                                            size='sm'
                                                            variant='primary'
                                                            onClick={() => handleViewDocuments(index, 'dokumen')}
                                                        >
                                                            Lihat Dokumen
                                                        </Button>
                                                        {
                                                            item.status === 'selesai_mutasi'
                                                                ?
                                                                <Button
                                                                    size='sm'
                                                                    variant={'outline-success'}
                                                                    disabled={true}
                                                                >
                                                                    <FaCheck className="text-success" size={20} title="Mutasi Selesai" /> Proses Mutasi Selesai
                                                                </Button>
                                                                :
                                                                // <Button
                                                                //     size='sm'
                                                                //     variant={isDocumentComplete(item) ? 'success' : 'warning'}
                                                                //     disabled={item.status === 'diajukan' || item.status === 'pending' || item.status === 'menerima' || item.status === 'disetujui' ? false : true}
                                                                //     onClick={() => handleOpenProsesMutasiModal(item)}
                                                                // >
                                                                //     <FaUpload /> Proses Mutasi
                                                                // </Button>
                                                                <Button
                                                                    size='sm'
                                                                    variant={'outline-secondary'}
                                                                    disabled={true}
                                                                >
                                                                    <FaExclamationTriangle className="text-warning" size={20} title="Mutasi Selesai" /> Proses Mutasi
                                                                </Button>
                                                        }
                                                    </ButtonGroup>
                                                </td>
                                            </tr>
                                            {/* Expanded Kendaraan View */}
                                            {expandedRow === index && viewType === 'kendaraan' && (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <div className="card border-info">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h6 className="card-title">Daftar Kendaraan</h6>
                                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleViewDocuments(index, 'kendaraan')}>
                                                                        <FaTimes /> Tutup
                                                                    </button>
                                                                </div>
                                                                <div className="row">
                                                                    {item.daftar_kendaraan.map((kendaraan, kIndex) => (
                                                                        <div key={kIndex} className="col-md-6 mb-2">
                                                                            <Card className="shadow-sm">
                                                                                <Card.Body>
                                                                                    <div className="d-flex align-items-center">
                                                                                        <FaCarAlt className="text-primary me-2" size={24} />
                                                                                        <div>
                                                                                            <Card.Title className="h6 mb-1">{kendaraan.nama_barang}</Card.Title>
                                                                                            <Card.Text className="mb-1">
                                                                                                <small className="text-muted">No. Polisi: {kendaraan.no_polisi || '-'}</small>
                                                                                            </Card.Text>
                                                                                            <Card.Text className="mb-0">
                                                                                                <small className="text-muted">No. BPKB: {kendaraan.no_bpkb || '-'}</small>
                                                                                            </Card.Text>
                                                                                        </div>
                                                                                    </div>
                                                                                </Card.Body>
                                                                            </Card>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                            {/* Expanded Dokumen View */}
                                            {expandedRow === index && viewType === 'dokumen' && (
                                                <tr>
                                                    <td colSpan={5}>
                                                        <div className="card border-primary">
                                                            <div className="card-body">
                                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                                    <h6 className="card-title">Dokumen</h6>
                                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleViewDocuments(index, 'dokumen')}>
                                                                        <FaTimes /> Tutup
                                                                    </button>
                                                                </div>
                                                                <div className="row">
                                                                    {/* Dokumen Permohonan SETDA */}
                                                                    <div className="col-md-3 mb-3">
                                                                        <div className="card h-100 border-warning">
                                                                            <div className="card-body text-center">
                                                                                <h6 className="card-title">Permohonan SETDA</h6>
                                                                                {item.dok_permohonan_setda ? (
                                                                                    <>
                                                                                        <div className="d-flex justify-content-center mb-2">
                                                                                            {getDocumentIcon(item.dok_permohonan_setda)}
                                                                                        </div>
                                                                                        <p className="card-text">
                                                                                            <small className="text-muted">No: {item.no_surat_dok_permohonan_setda || '-'}</small>
                                                                                        </p>
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="outline-primary"
                                                                                            onClick={() => handleDownloadDocument({ items: item, template: 'template_1' })}
                                                                                        >
                                                                                            <FaDownload /> Cetak
                                                                                        </Button>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '150px' }}>
                                                                                        <span className="text-muted">Belum ada dokumen</span>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-warning mt-2"
                                                                                            onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_1')}
                                                                                            disabled
                                                                                        >
                                                                                            <FaTimesCircle /> Menunggu Dokumen Diupload
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Dokumen Ketersediaan Menerima */}
                                                                    <div className="col-md-3 mb-3">
                                                                        <div className="card h-100 border-info">
                                                                            <div className="card-body text-center">
                                                                                <h6 className="card-title">Ketersediaan Menerima</h6>
                                                                                {item.dok_ketersediaan_menerima ? (
                                                                                    <>
                                                                                        <div className="d-flex justify-content-center mb-2">
                                                                                            {getDocumentIcon(item.dok_ketersediaan_menerima)}
                                                                                        </div>
                                                                                        <p className="card-text">
                                                                                            <small className="text-muted">No: {item.no_surat_dok_ketersediaan_menerima || '-'}</small>
                                                                                        </p>
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="outline-primary"
                                                                                            onClick={() => handleDownloadDocument({ items: item, template: 'template_2' })}
                                                                                        >
                                                                                            <FaDownload /> Cetak
                                                                                        </Button>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '150px' }}>
                                                                                        <span className="text-muted">Belum ada dokumen</span>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-warning mt-2"
                                                                                            onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_2')}
                                                                                            disabled
                                                                                        >
                                                                                            <FaTimesCircle /> Menunggu Dokumen Diupload
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Dokumen Persetujuan */}
                                                                    <div className="col-md-3 mb-3">
                                                                        <div className="card h-100 border-success">
                                                                            <div className="card-body text-center">
                                                                                <h6 className="card-title">Persetujuan</h6>
                                                                                {item.dok_persetujuan ? (
                                                                                    <>
                                                                                        <div className="d-flex justify-content-center mb-2">
                                                                                            {getDocumentIcon(item.dok_persetujuan)}
                                                                                        </div>
                                                                                        <p className="card-text">
                                                                                            <small className="text-muted">No: {item.no_surat_persetujuan || '-'}</small>
                                                                                        </p>
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="outline-primary"
                                                                                            onClick={() => handleDownloadDocument({ items: item, template: 'template_3' })}
                                                                                        >
                                                                                            <FaDownload /> Cetak
                                                                                        </Button>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '150px' }}>
                                                                                        <span className="text-muted">Belum ada dokumen</span>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-warning mt-2"
                                                                                            onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_3')}
                                                                                            disabled
                                                                                        >
                                                                                            <FaTimesCircle /> Menunggu Dokumen Diupload
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Dokumen BAST */}
                                                                    <div className="col-md-3 mb-3">
                                                                        <div className="card h-100 border-primary">
                                                                            <div className="card-body text-center">
                                                                                <h6 className="card-title">BAST</h6>
                                                                                {item.dok_bast ? (
                                                                                    <>
                                                                                        <div className="d-flex justify-content-center mb-2">
                                                                                            {getDocumentIcon(item.dok_bast)}
                                                                                        </div>
                                                                                        <p className="card-text">
                                                                                            <small className="text-muted">No: {item.no_surat_bast || '-'}</small>
                                                                                        </p>
                                                                                        <Button
                                                                                            size="sm"
                                                                                            variant="outline-primary"
                                                                                            onClick={() => handleDownloadDocument({ items: item, template: 'template_4' })}
                                                                                        >
                                                                                            <FaDownload /> Cetak
                                                                                        </Button>
                                                                                    </>
                                                                                ) : (
                                                                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '150px' }}>
                                                                                        <span className="text-muted">Belum ada dokumen</span>
                                                                                        <button
                                                                                            className="btn btn-sm btn-outline-warning mt-2"
                                                                                            onClick={() => handleOpenUploadModal(item.id_alih_status, 'template_4')}
                                                                                            disabled
                                                                                        >
                                                                                            <FaTimesCircle /> Menunggu Dokumen Diupload
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>

            {/* Upload Document Modal */}
            <Modal show={showUploadModal} onHide={handleCloseUploadModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Dokumen</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleUploadSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Nomor Surat</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Masukkan nomor surat"
                                value={nomorSurat}
                                onChange={(e) => setNomorSurat(e.target.value)}
                                required
                            />
                            <Form.Text className="text-muted">
                                Jika nomor surat lebih dari satu, pisahkan dengan tanda koma. Contoh: 'xxx/xxx/xxx,xxx/xxx/xxx'
                            </Form.Text>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Tanggal Surat</Form.Label>
                            <Form.Control
                                type="date"
                                value={tglSurat}
                                onChange={(e) => setTglSurat(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih File Dokumen</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleFileChange}
                                accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                                required
                            />
                            <Form.Text className="text-muted">
                                Format file yang diperbolehkan: DOC, DOCX, atau PDF
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseUploadModal}>
                            Batal
                        </Button>
                        <Button variant="primary" type="submit">
                            <FaTimesCircle /> Menunggu Dokumen Diupload Dokumen
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* Proses Mutasi Modal for BAST */}
            <Modal show={showProsesMutasiModal} onHide={handleCloseProsesMutasiModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Proses Mutasi Kendaraan</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleProsesMutasiSubmit}>
                    <Modal.Body>
                        <Alert variant="info">
                            <Alert.Heading>Mutasi Kendaraan</Alert.Heading>
                            <p>
                                Proses mutasi kendaraan akan membuat dokumen BAST (Berita Acara Serah Terima).
                                Silakan upload template BAST yang akan digunakan.
                            </p>
                        </Alert>
                        <Form.Group className="mb-3">
                            <Form.Label>OPD Asal: <strong>{data_opd.find(opd => opd.id === currentItem?.id_opd_asal)?.opd || '-'}</strong></Form.Label>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>OPD Tujuan: <strong>{data_opd.find(opd => opd.id === currentItem?.id_opd_tujuan)?.opd || '-'}</strong></Form.Label>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Pilih File Template BAST</Form.Label>
                            <Form.Control
                                type="file"
                                onChange={handleProsesMutasiFileChange}
                                accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
                                required
                            />
                            <Form.Text className="text-muted">
                                Format file yang diperbolehkan: DOC, DOCX, atau PDF
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseProsesMutasiModal}>
                            Batal
                        </Button>
                        <Button variant="success" type="submit">
                            <FaUpload /> Proses Mutasi
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </main>
    )
}

export default Admin_alih_status_kendaraan